// import { safetyGet } from 'Src/util/tool'
import { v4 as uuidv4 } from 'uuid'
// 当前tab唯一表示
window.sessionId = uuidv4()

// 初始页面停留时长
function handleDuration () {
  // 初始进入页面时间
  let startDuration = new Date().getTime()
  return () => {
    return (new Date().getTime() - startDuration) / 1000
  }
}

// 获取点击事件时长
const getDurationTime = handleDuration()

// 写入页面调用栈
function setPageStack () {
  let pageStack = JSON.parse(window.localStorage.getItem('pageStack')) || []
  pageStack.push(window.location.pathname)
  window.localStorage.setItem('pageStack', JSON.stringify(pageStack))
}

// 页面资源加载-起始
setPageStack()

// 页面的触发方式
let pageAction = 'open'
// 页面资源加载-完成
// window.onload = function () {
//   pageAction = 'loadfinish'
// }
// 当窗口即将被卸载（关闭）时,会触发该事件
window.addEventListener('beforeunload', () => {
  pageAction = 'close'
  // 处理内存泄漏的变量及缓存
  window.localStorage.setItem('pageStack', JSON.stringify([]))
})

// 写入页面映射map
function setPageMap (pageName) {
  let pageMap = JSON.parse(window.localStorage.getItem('pageMap')) || {}
  pageMap[window.location.pathname] = pageName
  window.localStorage.setItem('pageMap', JSON.stringify(pageMap))
}

// 获取起始页面
function getStartPageName (pageName) {
  let pageStack = JSON.parse(window.localStorage.getItem('pageStack')) || []
  let pageMap = JSON.parse(window.localStorage.getItem('pageMap')) || {}
  let startPageHref = pageStack[0] || ''
  return pageMap[startPageHref] || ''
}

// 获取前一页面
function getFrontPageName () {
  let pageStack = JSON.parse(window.localStorage.getItem('pageStack')) || []
  let pageMap = JSON.parse(window.localStorage.getItem('pageMap')) || {}
  let frontPageIndex = pageStack.indexOf(window.location.pathname) - 1
  if (frontPageIndex > -1) {
    let frontPageHref = pageStack[frontPageIndex]
    return pageMap[frontPageHref] || ''
  }
  return ''
}

// 获取起始url
function getStartPageUrl () {
  const pageStack = JSON.parse(window.localStorage.getItem('pageStack')) || []
  return pageStack[0] || ''
}

// 获取前一个url
function getFrontPageUrl () {
  const pageStack = JSON.parse(window.localStorage.getItem('pageStack')) || []
  const frontPageIndex = pageStack.indexOf(window.location.pathname) - 1
  return frontPageIndex > -1 ? pageStack[frontPageIndex] : ''
}

function teaEvent (teaEventName, params = {}, logType = 'event') {
  if (!teaEventName) return
  try {
    let paramsTEA = null
    if (typeof params === 'function') {
      let publicArr = teaEventName.split('_')
      let pageName = publicArr.slice(0, 2).join('_') || ''
      let eventName = publicArr.slice(2).join('_')
      setPageMap(pageName)
      const loc = window.location
      let baseObj = {
        log_type: logType,
        page_name: pageName,
        start_page_name: getStartPageName(),
        font_page_name: getFrontPageName(),
        event_name: eventName,
        sessionId: window.sessionId,
        core_user_id: GLOBAL_VAR.coreUser.id
      }
      let pageObj = {
        page_action: pageAction,
        close_mode: '',
        duration: getDurationTime(),
        url: loc.href,
        start_page_url: getStartPageUrl(),
        front_page_url: getFrontPageUrl(),
        page_url: loc.pathname
      }
      paramsTEA = { ...baseObj, ...(logType === 'page' ? pageObj : {}), ...params() }
    } else {
      paramsTEA = params
    }
    window.teaEvent(teaEventName, paramsTEA)
  } catch (e) {
    console.error('埋点取参逻辑报错')
  }
}

window.teaEventV1 = teaEvent
